let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import i18n from "../../utils/i18n";
let moment = require("moment");
import PrinterConverterUtil from "../../utils/PrinterConverterUtil.js";
import PrintService from "../../service/PrintService.js";
import POS from "../../POS";
let DbRecorder = require("../../recorder/DbRecorder.js");
let buildMembership = require("../../templates/pos/comp/buildMembership.handlebars");

let main = function () {
    return Backbone.View.extend({
        events: {
            'click .search': "_searchMembership",
            'click .charge':"_charge",
            'change .currency-choose':"_changeCurrency"
        },
        _charge:function(){
            var self = this,result;
            if (!_.every(this.$('input[name="chargeAmount"]'), function (item) {
                    var amount = Number($(item).val()), result = (_.isNumber(amount) && amount > 0);
                    return result;
                })) {
                alert(i18n.msg('pos.membership.topup.error.amount'));
                return;
            }
            var params = {
                id:self.$(".membership-details").data("memberid"),
                companyId: POS.getRestaurant().get('companyId'),
                restaurantId: POS.getRestaurant().id,
                currencyName:this.$(".currency-choose option:selected").text(),
                chargeType:this.$(".chargetype-choose option:selected").val().split("type.")[1],
                chargeAmount:this.$('input[name="chargeAmount"]').val(),
                description:this.$('input[name="description"]').val()
            };
            if (confirm(i18n.msg('pos.setting.membership.charge.confirm', POS.getRestaurant().get("currencySymbol")+params['chargeAmount']))) {
                result = $.post('/membership/charge', params);
                POS.showLoading(true);
                result.done(function (res) {
                    if (res.success) {
                        alert(i18n.msg('pos.charge.success'));
                        self._loadMemberInfo([res.membership],res.chargetypes);
                    } else {
                        alert('Charge fail');
                        return;
                    }
                    if (!POS.getPrinterSetting().isPrintable()) {
                        return;
                    }
                    var data,creditItem=res.creditItem;

                    PrintService.printMembershipCredit(creditItem);
                    data = PrinterConverterUtil.toMembershipReceipt(creditItem);
                    if (typeof(chrome) !== 'undefined' && typeof(chrome.runtime) !== 'undefined') {
                        chrome.runtime.sendMessage(DbRecorder.read("chromeAppId"), {msg: data})
                    }
                });

                result.fail(function () {
                    alert('Charge fail!');
                });
                result.always(function () {
                    POS.showLoading(false);
                });
            }
        },
        _changeCurrency:function(evt){
            var option = $(evt.currentTarget).find("option:selected");
            this.$(".credit").text(option?option.data("credit"):0);
        },
        _searchMembership: function () {
            var self = this, jxhr, restaurant = POS.getRestaurant(),name=self.$(".memberSearch").val();
            self.$(".membership-container").addClass("hidden");
            self.$(".no-member").addClass("hidden");
            if (!name || self.$(".membership-search .search").attr("disabled")) {
                return false;
            }
            self.$(".membership-search .search").attr("disabled", "disabled");
            POS.showLoading(true);
            jxhr = $.post("/membership/query", {restaurantId: restaurant.id, name: name,type:"charge"});
            jxhr.done(function(response){
                if(response.success){
                    if(response.memberships.length==0){
                        self.$(".no-member").removeClass("hidden");
                        return;
                    }
                    console.log(response);
                    self._loadMemberInfo(response.memberships,response.chargetypes);
                }
            });
            jxhr.always(function(response){
                POS.showLoading(false);
                self.$(".membership-search .search").removeAttr("disabled");
            });
            return false;
        },
        _loadMemberInfo:function(memberships,chargetypes){
            var self=this,member = memberships[0];
            if(member){
                if(member.scheme.discount){
                    member.discountName = member.scheme.discount.name;
                }
                member.symbol = POS.getRestaurant().get("currencySymbol");
                member.chargetypes = chargetypes;
                self.$(".membership-container").empty().append(buildMembership(member)).removeClass("hidden");
                var option = $(".currency-choose").find("option:selected");
                self.$(".credit").text(option?option.data("credit"):0);
            }
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/MembershipChargeView.js